module.exports = __webpack_public_path__ + "img/hypergraph_logo_invert.6650dcde.png";